<template>
  <STooltip v-if="props.tooltip" v-bind="props">
    <SButtonIcon
      action-type="quaternary"
      :disabled="props.disabled"
      :icon
      rounded
      size="inline"
    />
  </STooltip>
</template>

<script setup lang="ts">
import SButtonIcon from "@/lib/components/atoms/button/SButtonIcon.vue";
import STooltip from "@/lib/components/atoms/tooltip/STooltip.vue";
import * as useTooltip from "@/lib/components/logic/atoms/useTooltip";

const props = defineProps({
  icon: { type: String, default: "fas fa-info-circle" },
  ...useTooltip.props,
});
</script>
